import React, { Component } from 'react';
import {observer} from 'mobx-react';
import styles from './App.css';
import {Menu, News, Weather, Tabs, InputFlow, ElevatorField, OutputFlow, FooterMenu, PathPopup, Requests, Plan, FinanceData} from '../../components/index';
import {time, news, date, score, scenario, receptionBunkersStore, dcUnitsStore} from '../../stores/index';
import Results from "../Results";



@observer
export default class App extends Component {
    state = { tabs:0};

    componentWillMount(){
        document.querySelector("html").style.fontSize = (window.innerWidth)/120 + 'px';
        document.body.onresize = (e)=>{
            document.querySelector("html").style.fontSize = (e.target.innerWidth)/120 + 'px'
        }
    }

    setTabs(id){
        this.setState({tabs:id})
    }

    componentWillUnmount(){
        time.breaker();
    }
    
  render() {
    if(time.getTime && date.day.getFullYear()>=2020) return (
        <Results/>
        );
    return (
      <div className={styles.App}>
        {/*<Header/>*/}
          {/*<TopMenu news={news} time={time} date={date} />*/}
          <div className={styles.topMenuContainer}>
              <Menu score={score} />
              <News news={news} />
              <Weather time={time} date={date}/>
          </div>
          <div className={styles.shinkableOne} />
          <Tabs setTabs={this.setTabs.bind(this)} active={this.state.tabs}/>
          {this.state.tabs === 0 &&
          <div className={styles.gameContainer}>
              <InputFlow />
              <ElevatorField />
              <OutputFlow />
          </div>
          }
          {this.state.tabs === 1 &&
          <div className={styles.gameContainer}>
            <Requests />
          </div>
          }
          {this.state.tabs === 2 &&
          <div className={styles.gameContainer}>
             <Plan />
          </div>
          }
          {this.state.tabs === 3 &&
          <div className={styles.gameContainer}>
            <FinanceData />
          </div>
          }
          <div className={styles.shinkableTwo} />
          <FooterMenu time={time}/>
          {scenario.pathPopupStatus ?
              <PathPopup />
              : null}
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/shared/containers/App/App.js